module.exports = __webpack_public_path__ + "07_long_grey.c00d92f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/07_long_grey.png
// module id = HJ6q
// module chunks = 0